

















































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import SolicitudAfiliacionTitular from "@/models/tramite/senasa/solicitud-afiliacion-titular.model";
import SolicitudAfiliacionDependiente from "@/models/tramite/senasa/solicitud-afiliacion-dependiente.model";

@Component({})
export default class ConsultaSenasa extends BaseVue {
  @Prop() readonly cedula!: string;
  @Prop() readonly title!: string;
  requester = new BaseHttpClient("tramitebeneficiario");
  constructor() {
    super();
  }
  showSolicitudTitular = false;
  showSolicitudDependiente = false;
  message = String();
  loading = false;
  sending = false;
  solicitud = {
    titular: new SolicitudAfiliacionTitular(this.cedula),
    dependiente: new SolicitudAfiliacionDependiente(this.cedula)
  };
  get puedeSolicitar() {
    if (!this.message) return false;

    return this.message.toLocaleLowerCase().split("ok").length === 1;
  }
  created() {
    let props = [];
    props.push(
      new TipoTramiteComponentProp("cedula", "string", true, "Cédula"),
      new TipoTramiteComponentProp("title", "string", true, "Título")
    );
    this.$emit("render", props);
  }
  async solicitarAfiliacionTitular(){
    try {
      this.sending = true;
     let model = this.copy(this.solicitud.titular);
      let result = await this.requester.postAsync('senasa/solicitud/afiliacion/titular',model);
      this.operationSuccess();
      this.$router.push(`/lista-de-solicitudes`);
    } catch (error) {
      this.operationFailedErrors(error);
    } finally {
      this.sending = false;
    }
    
  }
  async solicitarAfiliacionDependiente(){
     try {
      this.sending = true;
    let model = this.copy(this.solicitud.dependiente);
    let result =  await this.requester.postAsync('senasa/solicitud/afiliacion/dependiente',model);
     this.operationSuccess();
      this.$router.push(`/lista-de-solicitudes`);
    } catch (error) {
      this.operationFailedErrors(error);
    } finally {
      this.sending = false;
    }
    
  }
  async getDatosAfiliado() {
    try {
      this.loading = true;
      this.message = await new BaseHttpClient("external").getAsync("senasa/consulta/afiliado", {
        cedula: this.cedula
      });
    } catch (error) {
      this.operationFailedErrors(error);
      this.message =
        "Ocurrió un error al tratar de obtener los datos del ciudadano, por favor comuníquese con su administrador o intentelo mas tarde.";
    } finally {
      this.loading = false;
    }
  }

  @Watch("cedula", { immediate: true })
  onPersonaIdChange(value: string) {
    if (!value) return;

    this.getDatosAfiliado();
  }
  init() {
    this.solicitud = {
      titular: new SolicitudAfiliacionTitular(this.cedula),
      dependiente: new SolicitudAfiliacionDependiente(this.cedula)
    };
  }
  cancelar() {
    this.showSolicitudTitular = false;
    this.showSolicitudDependiente = false;
    this.init();
  }
}
